__turbopack_context__.v({
  "SArrowButton": "CfiLhW_SArrowButton",
  "SLeftArrowSvg": "CfiLhW_SLeftArrowSvg" + " " + "CfiLhW_commonArrowStyles",
  "SMonth": "CfiLhW_SMonth",
  "SMonthWrapper": "CfiLhW_SMonthWrapper",
  "SRightArrowSvg": "CfiLhW_SRightArrowSvg" + " " + "CfiLhW_commonArrowStyles",
  "commonArrowStyles": "CfiLhW_commonArrowStyles",
});
